import { useEffect, useState, useCallback, useMemo, useContext } from "react";
import { LoadingDots } from "../../../components/general";
import { SearchComponent } from "../../../components/components/js/SearchComponent";
import { TableComponent } from "../../../components/components/js/TableComponent";
import { HeaderComponent } from "../../../components/components/js/HeaderComponent";
import AddRoomModal from "../../../components/components/js/RoomModal";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import API_URLS from "../../../constants/apiConstants";
import { downloadCSV, getFilters } from "../../../utils/exportUtils";
import AuthContext from "../../../context/AuthProvider";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ADMIN_ROOMS_ROUTE } from "../../../routes/RoutesPathes";

const COLUMNS = ["room", "capacity", "students", "actions"];

export const Rooms = () => {
  const axiosPrivate = useAxiosPrivate();

  const [rooms, setRooms] = useState([]);
  const navigate = useNavigate();
  const [filteredRooms, setFilteredRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  // const [expanded, setExpanded] = useState(false);
  const { school, auth } = useContext(AuthContext);
  const { t } = useTranslation();

  const filters = useMemo(() => getFilters(COLUMNS, t), [t]);
  const fetchRooms = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axiosPrivate.get(
        API_URLS.getRooms(auth.id, school.id)
      );

      const formattedData = response.data.map((room) => ({
        id: room.id,
        image: room.Image ? room.Image : "",
        room: room.ClassName,
        capacity: room.Capacity,
        students: room.student_set?.length || 0,
      }));

      setRooms(formattedData);
      setFilteredRooms(formattedData);
    } catch (error) {
      console.error("GET request error:", error);
      setError("Failed to load rooms. Please try again later.");
      setRooms([]);
    } finally {
      setLoading(false);
    }
  }, [auth.id, axiosPrivate, school.id]);

  useEffect(() => {
    fetchRooms();
  }, [fetchRooms]);

  const handleCloseAddModal = () => setShowAddModal(false);
  const handleOpenAddModal = () => setShowAddModal(true);
  // const collapseNav = () => setExpanded(false);

  const handleNavigate = (row) => {
    navigate(`/admin/rooms/${row.id}/students?room=${encodeURIComponent(row.room)}`, {
      state: {
        className: row.room,
      },
    });
  };

  const handleExport = () => {
    const headers = COLUMNS.filter((col) => col.key !== "actions").map(
      (column) => column.label
    );
    const data = rooms.map((room) => [room.room, room.capacity, room.students]);
    downloadCSV(data, headers, "Rooms");
  };

  const handleSearch = (value, filter) => {
    if (!value || !filter) return setFilteredRooms(rooms);

    const query = value.toLowerCase();
    const results = rooms.filter((s) => {
      console.log(s[filter]);
      return s[filter].toString().toLowerCase().includes(query);
    });
    console.log(results);
    setFilteredRooms(results);
  };

  const handleDelete = async (row) => {
    if (!row) return;

    try {
      setLoading(true);
      await axiosPrivate.delete(`${API_URLS.room}/${row.id}`);
      fetchRooms();
    } catch (error) {
      console.error("Delete request error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-block ms-auto px-4"
      style={{
        minHeight: "70vh",
      }}
    >
      <HeaderComponent
        buttonName="add_room"
        export_fn={handleExport}
        setShow={handleOpenAddModal}
        title="rooms"
      />

      <SearchComponent
        items={filters}
        onSearch={handleSearch}
        placeholder={"room"}
      />

      {loading ? (
        <LoadingDots />
      ) : error ? (
        <div className="d-flex justify-content-center align-items-center vh-100 fw-bold fs-1 text-danger">
          {error}
        </div>
      ) : filteredRooms.length > 0 ? (
        <TableComponent
          columns={COLUMNS}
          data={filteredRooms}
          page="room"
          onEdit={handleNavigate}
          onDelete={handleDelete}
          getRowUrl={(row) => `${ADMIN_ROOMS_ROUTE}/${row.id}/students`}
        />
      ) : (
        <div className="d-flex justify-content-center align-items-center vh-100 fw-bold fs-1">
          {t("noRooms")}
        </div>
      )}

      <AddRoomModal
        open={showAddModal}
        onClose={handleCloseAddModal}
        modalName="add"
      />
    </div>
  );
};
